import { TableCell, Typography } from "@mui/material";
import type { EmailAccountInfo, SmtpLoginStatus } from "../../../api/emailAccountsTypes";
import { unusableReasonLabels } from "./emailAccountsLabels";
import SmtpLoginChip from "./SmtpLoginChip";

interface Props {
  account: EmailAccountInfo;
  clientCode?: string;
  smtpLoginStatus?: SmtpLoginStatus;
}

const getDisplayNames = (account: EmailAccountInfo, clientCode?: string) =>
  [
    ...new Set(
      account.clients
        .filter((client) => clientCode === undefined || client.clientCode.toLowerCase() === clientCode.toLowerCase())
        .map((client) => client.displayName)
        .filter((name) => !!name)
    ),
  ].join(", ");

const EmailAccountCells = ({ account, clientCode, smtpLoginStatus }: Props) => (
  <>
    <TableCell>{account.address}</TableCell>
    <TableCell>{getDisplayNames(account, clientCode)}</TableCell>
    <TableCell>
      {account.domainName} {account.domainState && `(${account.domainState})`}
    </TableCell>
    <TableCell>{account.enabled ? "Yes" : "No"}</TableCell>
    <TableCell>
      {account.unusableReason ? (
        <Typography color="warning">{unusableReasonLabels[account.unusableReason]}</Typography>
      ) : (
        "Yes"
      )}
    </TableCell>
    <TableCell>
      <SmtpLoginChip status={smtpLoginStatus} />
    </TableCell>
  </>
);

export default EmailAccountCells;
